// shared
export const QUERY_INIT = "QUERY_INIT";
export const CONFIG_INIT = "CONFIG_INIT";
export const GAME_CONFIG_LOADED = "GAME_CONFIG_LOADED";

// high-frequency-word
export const HIGH_FREQUENCY_WORD_IMPORT = "HIGH_FREQUENCY_WORD_IMPORT";
export const HIGH_FREQUENCY_INIT_SPEC = "HIGH_FREQUENCY_INIT_SPEC";
export const HIGH_FREQUENCY_SELECT_TRUCK = "HIGH_FREQUENCY_SELECT_TRUCK";
export const HIGH_FREQUENCY_SELECT_TRUCK_TYPE =
  "HIGH_FREQUENCY_SELECT_TRUCK_TYPE";
export const HIGH_FREQUENCY_SELECT_PLACE = "HIGH_FREQUENCY_SELECT_PLACE";
export const HIGH_FREQUENCY_START_GAME = "HIGH_FREQUENCY_START_GAME";
export const HIGH_FREQUENCY_SET_NEW_ROUND = "HIGH_FREQUENCY_SET_NEW_ROUND";
export const HIGH_FREQUENCY_TRUCK_ACTIVE = "HIGH_FREQUENCY_TRUCK_ACTIVE";
export const HIGH_FREQUENCY_TRUCK_TRANS = "HIGH_FREQUENCY_TRUCK_TRANS";
export const HIGH_FREQUENCY_TRUCK_LEFT = "HIGH_FREQUENCY_TRUCK_LEFT";
export const HIGH_FREQUENCY_DRAG = "HIGH_FREQUENCY_DRAG";
export const HIGH_FREQUENCY_CHECK_ANSWER = "HIGH_FREQUENCY_CHECK_ANSWER";
export const HIGH_FREQUENCY_CANCEL_RESPONSE = "HIGH_FREQUENCY_CANCEL_RESPONSE";
export const HIGH_FREQUENCY_RESET_DISPLAY = "HIGH_FREQUENCY_RESET_DISPLAY";
export const HIGH_FREQUENCY_FINISH = "HIGH_FREQUENCY_FINISH";
export const HIGH_FREQUENCY_PLAY_AGAIN = "HIGH_FREQUENCY_PLAY_AGAIN";
export const HIGH_FREQUENCY_FIRST_CLICK = "HIGH_FREQUENCY_FIRST_CLICK";

// content-word
export const CONTENT_WORD_IMPORT = "CONTENT_WORD_IMPORT";
export const CONTENT_WORD_START_PLAY = "CONTENT_WORD_START_PLAY";
export const CONTENT_WORD_INIT_GAME = "CONTENT_WORD_INIT_GAME";
export const CONTENT_WORD_SELECT_ROUND = "CONTENT_WORD_SELECT_ROUND";
export const CONTENT_WORD_SHUFFLE = "CONTENT_WORD_SHUFFLE";
export const CONTENT_WORD_COUNTDOWN = "CONTENT_WORD_COUNTDOWN";
export const CONTENT_WORD_SET_ANSWER = "CONTENT_WORD_SET_ANSWER";
export const CONTENT_WORD_SET_DISPLAY = "CONTENT_WORD_SET_DISPLAY";
export const CONTENT_WORD_SELECT_ANSWER = "CONTENT_WORD_SELECT_ANSWER";
export const CONTENT_WORD_END_RESPONSE = "CONTENT_WORD_END_RESPONSE";
export const CONTENT_WORD_TIMES_UP = "CONTENT_WORD_TIMES_UP";
export const CONTENT_WORD_PLAY_AGAIN = "CONTENT_WORD_PLAY_AGAIN";

// phoneme
export const PHONEME_IMPORT_SPEC = "PHONEME_IMPORT_SPEC";
export const PHONEME_BACK_TO_INTRO = "PHONEME_BACK_TO_INTRO";
export const PHONEME_FIRST_CLICK = "PHONEME_FIRST_CLICK";
export const PHONEME_INSTRUCTION = "PHONEME_INSTRUCTION";

export const PHONEME_BALLOON_START = "PHONEME_BALLOON_START";
export const PHONEME_BALLOON_READY = "PHONEME_BALLOON_READY";
export const PHONEME_BALLOON_SELECT = "PHONEME_BALLOON_SELECT";
export const PHONEME_BALLOON_CLEAR_ANSWER = "PHONEME_BALLOON_CLEAR_ANSWER";
export const PHONEME_BALLON_NOT_CLICKABLE = "PHONEME_BALLON_NOT_CLICKABLE";
export const PHONEME_BALLON_READY_END = "PHONEME_BALLON_READY_END";
export const PHONEME_BALLON_END = "PHONEME_BALLON_END";

export const PHONEME_BASKET_START = "PHONEME_BASKET_START";
export const PHONEME_BASKET_SELECT = "PHONEME_BASKET_SELECT";
export const PHONEME_BASKET_RESPONSE = "PHONEME_BASKET_RESPONSE";
export const PHONEME_BASKET_CLEAR = "PHONEME_BASKET_CLEAR";
export const PHONEME_BASKET_READY_END = "PHONEME_BASKET_READY_END";
export const PHONEME_BASKET_END = "PHONEME_BASKET_END";

export const PHONEME_CLOUD_START = "PHONEME_CLOUD_START";
export const PHONEME_CLOUD_SET_ROUND = "PHONEME_CLOUD_SET_ROUND";
export const PHONEME_CLOUD_CLICKABLE = "PHONEME_CLOUD_CLICKABLE";
export const PHONEME_CLOUD_PLAY = "PHONEME_CLOUD_PLAY";
export const PHONEME_CLOUD_PLAY_END = "PHONEME_CLOUD_PLAY_END";
export const PHONEME_CLOUD_PLAY_NEXT = "PHONEME_CLOUD_PLAY_NEXT";
export const PHONEME_CLOUD_CLICK = "PHONEME_CLOUD_CLICK";
export const PHONEME_CLOUD_READY_END = "PHONEME_CLOUD_READY_END";
export const PHONEME_CLOUD_END = "PHONEME_CLOUD_END";

// blending
export const BLENDING_IMPORT = "BLENDING_IMPORT";
export const BLENDING_SET_ROUND = "BLENDING_SET_ROUND";
export const BLENDING_SET_ORIGINAL_ALPHABET_LIST =
  "BLENDING_SET_ORIGINAL_ALPHABET_LIST";
export const BLENDING_RESET_ALPHABET_LIST = "BLENDING_RESET_ALPHABET_LIST";
export const BLENDING_RESET_ANSWERED = "BLENDING_RESET_ANSWERED";
export const BLENDING_DRAG_CARD = "BLENDING_DRAG_CARD";
export const BLENDING_CHECK_ANSWER = "BLENDING_CHECK_ANSWER";
export const BLENDING_CANCEL_RESPONSE = "BLENDING_CANCEL_RESPONSE";
export const BLENDING_FINISHED = "BLENDING_FINISHED";
export const BLENDING_PLAY_AGAIN = "BLENDING_PLAY_AGAIN";
export const BLENDING_SET_IS_SINGLE_ROW = "BLENDING_SET_IS_SINGLE_ROW";
